import { getComicPageTransitionElementStyle } from "./erComicPageTransition";
import { getScatterPageTransitionElementStyle } from "./erScatterPageTransition";
import { getRevealPageTransitionElementStyle } from "./erRevealPageTransition";
import {
	isStaggerEffectTransition,
	getStaggerEffectPageTransitionElementStyle,
} from "./erStaggerEffectTransitions";
const RETIRED_ENTRY_ANIMATION_IDS = new Set([
	"brushStroke",
	"brushStrokeReverse",
	"mosaic",
	"iris",
	"shutter",
	"pageTurn",
	"sand",
]);

export function normalizeEntryAnimationForPlay(id) {
	const v = id || "none";
	return RETIRED_ENTRY_ANIMATION_IDS.has(v) ? "fade" : v;
}

/**
 * Estilos de animación de entrada al montar / cambiar de página.
 * `both` + estado inicial evita que el elemento parpadee visible antes del primer fotograma.
 */
export function getElementEntryAnimationStyle(element, pageAnimKey, options = {}) {
	const {
		pageTransitionType,
		staggerIndex,
		staggerTotal,
		pageTransitionDurationMs,
	} = options;

	if (pageAnimKey && pageTransitionType && staggerIndex != null) {
		if (pageTransitionType === "comic") {
			return getComicPageTransitionElementStyle(
				staggerIndex,
				staggerTotal,
				pageTransitionDurationMs,
				element?.elementId
			);
		}
		if (pageTransitionType === "scatter") {
			return getScatterPageTransitionElementStyle(
				staggerIndex,
				staggerTotal,
				pageTransitionDurationMs,
				element
			);
		}
		if (pageTransitionType === "reveal") {
			return getRevealPageTransitionElementStyle(
				staggerIndex,
				staggerTotal,
				pageTransitionDurationMs,
				element
			);
		}
		if (isStaggerEffectTransition(pageTransitionType)) {
			return getStaggerEffectPageTransitionElementStyle(
				pageTransitionType,
				staggerIndex,
				staggerTotal,
				pageTransitionDurationMs,
				element
			);
		}
	}	if (!pageAnimKey) return {};
	let anim = normalizeEntryAnimationForPlay(element?.entryAnimation);
	if (anim === "typewriter") return {};
	const afterSec =
		element?.type === "button" && String(element?.content?.showWhen || "") === "afterSeconds";
	if (anim === "none" && afterSec) anim = "fade";
	if (anim === "none") return {};
	const ms = Number(element?.entryAnimationDuration);
	const durSec = (Number.isFinite(ms) && ms > 0 ? ms : 500) / 1000;
	const initial =
		anim === "slideLeft"
			? { opacity: 0, transform: "translateX(16%)" }
			: anim === "slideRight"
				? { opacity: 0, transform: "translateX(-16%)" }
				: anim === "slideUp"
					? { opacity: 0, transform: "translateY(16%)" }
					: anim === "slideDown"
						? { opacity: 0, transform: "translateY(-16%)" }
						: anim === "zoom"
							? { opacity: 0, transform: "scale(0.88)" }
							: anim === "comic"
								? { opacity: 0, transform: "scale(1.2) rotate(-3deg)" }
								: anim === "scatter"
									? { opacity: 0, transform: "translateY(24px) scale(0.92)", filter: "blur(4px)" }
									: anim === "reveal"
										? { opacity: 0, transform: "translateY(-52px) rotate(-6deg) scale(0.9)" }
									: anim === "materialize"
										? { opacity: 0, filter: "blur(12px) saturate(0.15) brightness(1.7)" }
									: anim === "build"
										? {
												opacity: 0,
												transform: "translate3d(0, 16px, 0) scale(1.015)",
												filter: "drop-shadow(0 12px 20px rgba(0, 0, 0, 0.28))",
											}
									: anim === "static"
										? { opacity: 0, filter: "contrast(3) brightness(1.8) blur(1px)" }
									: anim === "thermal"
										? { opacity: 0, transform: "scale(0.9)", filter: "blur(6px) brightness(2) drop-shadow(0 0 14px rgba(0,255,220,0.85))" }
									: anim === "softGlitch"
										? { opacity: 0, transform: "translate(8px, -3px) skewX(4deg)", filter: "drop-shadow(6px 0 #ff00c8) drop-shadow(-6px 0 #00e5ff) contrast(2.4)" }
									: anim === "mist"
										? { opacity: 0, transform: "translateY(18px)", filter: "blur(12px) saturate(0.18) brightness(1.35) hue-rotate(195deg)" }
									: anim === "shadow"
										? { opacity: 0, transform: "scale(1.12)", filter: "brightness(0.18) contrast(1.75) blur(3px)" }
									: anim === "omen"
										? { opacity: 0, transform: "rotate(2.5deg) scale(0.94)", filter: "brightness(1.55) hue-rotate(280deg) drop-shadow(0 0 12px rgba(76,29,149,0.65))" }
									: anim === "clinical"
										? { opacity: 0, transform: "translateY(10px) scale(0.96)", filter: "blur(6px) brightness(1.3) hue-rotate(-18deg) drop-shadow(0 0 12px rgba(16,185,129,0.55))" }
									: { opacity: 0 };	return {
		...initial,
		animation: `er-entry-${anim} ${durSec}s ease-out both`,
		willChange:
			anim === "fade"
				? "opacity"
				: anim === "materialize" || anim === "static"
					? "opacity, filter"
					: anim === "thermal" || anim === "softGlitch" || anim === "mist" || anim === "shadow" || anim === "omen" || anim === "build" || anim === "clinical"
						? "opacity, transform, filter, clip-path"
						: "opacity, transform",
	};
}

/** Typewriter de entrada (entryAnimation === "typewriter") o del contenido. */
export function resolveTextTypewriterDurationSec(element) {
	const entryAnim = normalizeEntryAnimationForPlay(element?.entryAnimation);
	const twEntryMs = entryAnim === "typewriter" ? Number(element?.entryAnimationDuration) : NaN;
	const twEntrySec = Number.isFinite(twEntryMs) && twEntryMs > 0 ? twEntryMs / 1000 : 0;
	const contentTwSec = Number(element?.content?.typewriterDurationSec);
	if (twEntrySec > 0) return twEntrySec;
	if (entryAnim !== "typewriter" && Number.isFinite(contentTwSec) && contentTwSec > 0) return contentTwSec;
	return 0;
}
